<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/kbfPgB/images/9780316134392.jpg?1732137048480" alt="This image is the cover for the book Equations of Life, Samuil Petrovitch"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Equations of Life, Samuil Petrovitch
      </h1>
      <p class="bookDescription body article font2">
        <i>Winner of the 2012 Philip K. Dick Award</i><br/><br/>Samuil Petrovitch is a survivor.<br/><br/>He survived the nuclear fallout in St. Petersburg and hid in the London Metrozone -- the last city in England. He's lived this long because he's a man of rules and logic.<br/><br/>For example, getting involved = a bad idea.<br/><br/>But when he stumbles into a kidnapping in progress, he acts without even thinking. Before he can stop himself, he's saved the daughter of the most dangerous man in London.<br/><br/>And clearly saving the girl = getting involved.<br/><br/>Now, the equation of Petrovitch's life is looking increasingly complex.<br/><br/>Russian mobsters + Yakuza + something called the New Machine Jihad = one dead Petrovitch.<br/><br/>But Petrovitch has a plan -- he always has a plan -- he's just not sure it's a good one.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Simon Morden
      </h2>
      
      <p class="authorDescription body article"><B>Dr. Simon Morden</B> holds degrees in geology and planetary geophysics. He was born in Gateshead, England and now resides in Worthing, England. Find out more about Simon Morden at www.simonmorden.com.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Orbit
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?7ba383b4